"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hierarchy = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var HierarchyTypeUtil_1 = require("../../HierarchyTypeUtil");
var HierarchyStyledComponents_1 = require("./HierarchyStyledComponents");
var Node_1 = require("./Node");
var NodeSelectionTypes_1 = require("./NodeSelectionTypes");
var Hierarchy = /** @class */ (function (_super) {
    __extends(Hierarchy, _super);
    function Hierarchy(props) {
        var _this = _super.call(this, props) || this;
        _this.getTotalRollupCount = function (selectionCriteria) {
            var totalRollups = 0;
            if (!selectionCriteria) {
                return;
            }
            totalRollups += getRollups(selectionCriteria.descendantsIncluded);
            totalRollups += getRollups(selectionCriteria.singleIncluded);
            return totalRollups;
            function getRollups(includededList) {
                var rollups = 0;
                if (includededList && Object.keys(includededList).length > 0) {
                    Object.keys(includededList).forEach(function (key, i) {
                        rollups += includededList[key].totalRollups;
                    });
                }
                return rollups;
            }
        };
        _this.crumbDismissDescendants = function (crumbs) {
            return _this.crumbDismiss(crumbs, NodeSelectionTypes_1.NodeSelectionTypes.ItemAndBelow);
        };
        _this.crumbDismissSingle = function (crumbs) {
            return _this.crumbDismiss(crumbs, NodeSelectionTypes_1.NodeSelectionTypes.OnlyItem);
        };
        _this.crumbDismiss = function (crumbs, nodeSelectionType) {
            var updatedCriteria = __assign({}, _this.state.selectionCriteria);
            var includedNodes = {};
            switch (nodeSelectionType) {
                case NodeSelectionTypes_1.NodeSelectionTypes.ItemAndBelow:
                    includedNodes = updatedCriteria.descendantsIncluded;
                    break;
                case NodeSelectionTypes_1.NodeSelectionTypes.OnlyItem:
                    includedNodes = updatedCriteria.singleIncluded;
                    break;
            }
            var selectedNodeIds = crumbs.map(function (crumb) { return crumb.value; });
            var singleIncludedNodeIds = (includedNodes && Object.keys(includedNodes)) || [];
            if (singleIncludedNodeIds.length > 0) {
                singleIncludedNodeIds.map(function (nodeId) {
                    if (!selectedNodeIds.includes(nodeId)) {
                        delete includedNodes[nodeId];
                    }
                });
            }
            _this.updateSelectionCriteria(updatedCriteria);
        };
        var allNodesIncluded = props.selectionCriteria ? props.selectionCriteria.allNodesIncluded : false;
        _this.state = {
            selectAll: allNodesIncluded,
            selectItemAndBelow: true,
            levelOptions: [],
            isInvalidNodeIdsFixed: false,
            selectionCriteria: props.selectionCriteria
                ? {
                    singleIncluded: __assign({}, props.selectionCriteria.singleIncluded),
                    descendantsIncluded: __assign({}, props.selectionCriteria.descendantsIncluded),
                    allNodesIncluded: props.selectionCriteria.allNodesIncluded,
                }
                : {
                    singleIncluded: {},
                    descendantsIncluded: {},
                    allNodesIncluded: false,
                },
        };
        _this.selectAllSwitchChanged = _this.selectAllSwitchChanged.bind(_this);
        _this.resetSelectionCriteria = _this.resetSelectionCriteria.bind(_this);
        _this.onChangeSelectNode = _this.onChangeSelectNode.bind(_this);
        _this.crumbDismissDescendants = _this.crumbDismissDescendants.bind(_this);
        _this.crumbDismissSingle = _this.crumbDismissSingle.bind(_this);
        _this.crumbDismiss = _this.crumbDismiss.bind(_this);
        _this.SanitizeSelectionCriteria = _this.SanitizeSelectionCriteria.bind(_this);
        _this.displayCrumb = _this.displayCrumb.bind(_this);
        _this.selectLevels = _this.selectLevels.bind(_this);
        _this.hasSelectedNodes = _this.hasSelectedNodes.bind(_this);
        _this.displaySelectedCrumbs = _this.displaySelectedCrumbs.bind(_this);
        _this.getLevelOptions = _this.getLevelOptions.bind(_this);
        return _this;
    }
    Hierarchy.prototype.componentDidMount = function () {
        this.SanitizeSelectionCriteria(undefined);
    };
    // Validate and remove any invalid node ids in selectionCriteria being injected by parent component
    Hierarchy.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (this.props.invalidNodeIds && this.state.selectionCriteria && !this.state.isInvalidNodeIdsFixed) {
            // If invalid node ids found, remove them from selectionCriteria
            var selectionCriteria_1 = {
                singleIncluded: {},
                descendantsIncluded: {},
                allNodesIncluded: this.state.selectionCriteria.allNodesIncluded,
            };
            // Remove duplicate nodes
            this.UpdateSelectionCriteriaUsingInvalidIds(this.state.selectionCriteria.singleIncluded, selectionCriteria_1.singleIncluded, true);
            this.UpdateSelectionCriteriaUsingInvalidIds(this.state.selectionCriteria.descendantsIncluded, selectionCriteria_1.descendantsIncluded, false);
            // Merge nodes
            var descendantsIncludedIds = Object.keys(selectionCriteria_1.descendantsIncluded);
            descendantsIncludedIds.forEach(function (nodeId) {
                _this.mergeNodeSelections(selectionCriteria_1, nodeId, false);
            });
            this.setState({ selectionCriteria: selectionCriteria_1, isInvalidNodeIdsFixed: true });
            this.props.onChangeSelectionCriteria(selectionCriteria_1);
        }
        if (this.props.selectionCriteria &&
            prevProps.selectionCriteria &&
            !lodash_1.default.isEqual(prevProps.selectionCriteria, this.props.selectionCriteria) &&
            !lodash_1.default.isEqual(this.props.selectionCriteria, this.state.selectionCriteria)) {
            // When the selectionCriteria is changed in props, verify the criteria for any invald node ids
            // Assumption: this is only injected/changed once and will not change during the component's lifetime
            this.SanitizeSelectionCriteria(prevProps);
            this.updateSelectionCriteria({
                singleIncluded: __assign({}, this.props.selectionCriteria.singleIncluded),
                descendantsIncluded: __assign({}, this.props.selectionCriteria.descendantsIncluded),
                allNodesIncluded: this.state.selectionCriteria.allNodesIncluded,
            });
        }
        if (this.props.nodes !== prevProps.nodes) {
            this.getLevelOptions();
        }
    };
    Hierarchy.prototype.render = function () {
        var _this = this;
        var _a = this.props, hideselectItemRadioButtons = _a.hideselectItemRadioButtons, hideSelectType = _a.hideSelectType, rootLevelNodes = _a.rootLevelNodes, disableSelectAll = _a.disableSelectAll, hideClearButton = _a.hideClearButton;
        var selectionCriteria = this.state.selectionCriteria;
        var items = [
            { name: NodeSelectionTypes_1.NodeSelectionTypes.ItemAndBelow, checked: this.state.selectItemAndBelow, displayText: 'Select Item & All Below' },
            { name: NodeSelectionTypes_1.NodeSelectionTypes.OnlyItem, checked: !this.state.selectItemAndBelow, displayText: 'Select Item Only' },
        ];
        if (this.props.isLoading) {
            return (React.createElement(aon_tws_common_ui_1.Loading, { height: '60px', width: '60px' }, "Loading..."));
        }
        if (rootLevelNodes) {
            var topNodes = rootLevelNodes.map(function (nodeId) {
                return _this.getTopNode(nodeId, false);
            });
            var orphanNodes = rootLevelNodes.map(function (nodeId) {
                return _this.getTopNode(nodeId, true);
            });
            var nodeSelectionType = this.state.selectItemAndBelow ? NodeSelectionTypes_1.NodeSelectionTypes.ItemAndBelow : NodeSelectionTypes_1.NodeSelectionTypes.OnlyItem;
            return (React.createElement(HierarchyStyledComponents_1.HierarchyContainer, { className: this.props.className },
                React.createElement(HierarchyStyledComponents_1.HierarchyGraphContainer, null,
                    !hideSelectType && (React.createElement(HierarchyStyledComponents_1.SelectTypeContainer, null,
                        React.createElement(HierarchyStyledComponents_1.SelectTypeRadio, { hidden: hideselectItemRadioButtons },
                            React.createElement(aon_tws_common_ui_1.Radio, { name: 'nodeSelectionTypeRadio', items: items, value: nodeSelectionType, alignDirection: 'Horizontal', disabled: this.state.selectAll, size: 'sm', onChange: function (e) {
                                    _this.setState({ selectItemAndBelow: e === NodeSelectionTypes_1.NodeSelectionTypes.ItemAndBelow });
                                } })),
                        React.createElement(HierarchyStyledComponents_1.SelectTypeSwitch, null,
                            React.createElement(HierarchyStyledComponents_1.SwitchContainer, null,
                                React.createElement(aon_tws_common_ui_1.Switch, { text: 'Select All', checked: this.state.selectAll, disabled: disableSelectAll, getValue: this.selectAllSwitchChanged }))))),
                    React.createElement(HierarchyStyledComponents_1.NodesContainer, null,
                        topNodes,
                        React.createElement(HierarchyStyledComponents_1.Divider, null,
                            React.createElement("div", null, "Unparented"),
                            React.createElement(HierarchyStyledComponents_1.DividerLine, null)),
                        this.getOrphanedDependentNodes(),
                        orphanNodes)),
                React.createElement(HierarchyStyledComponents_1.SelectedContainer, null,
                    React.createElement(HierarchyStyledComponents_1.SelectedHeader, null, "Selected Hierarchy Nodes"),
                    React.createElement(HierarchyStyledComponents_1.SelectedClearButton, { hidden: hideClearButton },
                        React.createElement(aon_tws_common_ui_1.Button, { className: 'tws-clear-selections', size: 'xs', onClick: function () { return _this.resetSelectionCriteria(); } }, "Clear")),
                    React.createElement(HierarchyStyledComponents_1.CrumbsContainer, null,
                        this.hasSelectedNodes() && (React.createElement(aon_tws_common_ui_1.Crumblist, { data: [
                                {
                                    displayText: 'Selected Node Count',
                                    value: '0',
                                    isDismissible: false,
                                    icon: 'hierarchy',
                                    count: this.getTotalRollupCount(selectionCriteria),
                                },
                            ] })),
                        this.displaySelectedCrumbs(selectionCriteria.descendantsIncluded, this.crumbDismissDescendants),
                        this.displaySelectedCrumbs(selectionCriteria.singleIncluded, this.crumbDismissSingle)))));
        }
        else {
            return React.createElement(React.Fragment, null, " ");
        }
    };
    Hierarchy.prototype.getLevelOptions = function () {
        var _a, _b;
        var nodeList = lodash_1.default.map(this.props.nodes);
        var maxLevel = (_b = (_a = lodash_1.default.maxBy(nodeList, function (n) { return n.level; })) === null || _a === void 0 ? void 0 : _a.level) !== null && _b !== void 0 ? _b : 0;
        var levelOptions = [];
        for (var i = 1; i <= maxLevel; i++) {
            levelOptions.push({ name: "".concat(i), displayText: "".concat(i) });
        }
        this.setState({ levelOptions: levelOptions });
    };
    Hierarchy.prototype.displaySelectedCrumbs = function (includedNodes, dismissCrumbs) {
        var selectionCriteria = this.state.selectionCriteria;
        return selectionCriteria && includedNodes && Object.keys(includedNodes).length > 0 && this.displayCrumb(includedNodes, dismissCrumbs);
    };
    Hierarchy.prototype.hasSelectedNodes = function () {
        var selectionCriteria = this.state.selectionCriteria;
        return ((selectionCriteria && selectionCriteria.descendantsIncluded && Object.keys(selectionCriteria.descendantsIncluded).length > 0) ||
            (selectionCriteria.singleIncluded && Object.keys(selectionCriteria.singleIncluded).length > 0));
    };
    Hierarchy.prototype.displayCrumb = function (includedNodes, dismissCrumbs) {
        return (React.createElement(HierarchyStyledComponents_1.SelectedCrumb, { enableDismiss: this.props.enableDismiss && !this.state.selectAll, data: Object.keys(includedNodes).map(function (key, i) {
                if (includedNodes[key]) {
                    return {
                        displayText: includedNodes[key].name,
                        value: key,
                        sequence: i,
                        count: includedNodes[key].totalRollups,
                    };
                }
                return {};
            }), update: dismissCrumbs }));
    };
    Hierarchy.prototype.resetSelectionCriteria = function () {
        var selectionCriteria = {
            descendantsIncluded: {},
            singleIncluded: {},
            allNodesIncluded: false,
        };
        this.setState({ selectionCriteria: selectionCriteria, selectAll: false });
        this.props.onChangeSelectionCriteria(selectionCriteria);
    };
    Hierarchy.prototype.getOrphanedDependentNodes = function () {
        var _this = this;
        if (this.props.orphanedDependentNodeIds && this.props.orphanedDependentNodeIds.items.length > 0) {
            var topNodes = this.props.orphanedDependentNodeIds.items.map(function (nodeId) {
                return _this.getTopNode(nodeId, true);
            });
            return (React.createElement(React.Fragment, null,
                topNodes,
                this.props.orphanedDependentNodeIds.items.length < this.props.orphanedDependentNodeIds.pageRange.total && (React.createElement(HierarchyStyledComponents_1.LoadMoreOrphanNodesButtonContainer, null,
                    React.createElement(aon_tws_common_ui_1.Button, { size: 'xs', className: 'tws-button-load-more-orphan-top-nodes', onClick: function () { return _this.props.loadMoreTopLevelOrphanNodes(); } }, "Load More")))));
        }
        return undefined;
    };
    Hierarchy.prototype.selectAllSwitchChanged = function (e) {
        var _this = this;
        if (!this.props.rootLevelNodes) {
            return false;
        }
        var updatedCriteria = {
            descendantsIncluded: {},
            singleIncluded: {},
            allNodesIncluded: !this.state.selectAll,
        };
        if (!this.state.selectAll) {
            this.props.rootLevelNodes.forEach(function (nodeId) {
                var nodeVm = _this.props.nodes[nodeId];
                updatedCriteria.descendantsIncluded[nodeId] = {
                    name: _this.getHierarchyTypeUtil().getNodeDisplayName({ nodeVm: nodeVm, fullName: true }),
                    id: nodeId,
                    totalRollups: _this.getHierarchyTypeUtil().getDescendantNodeCount(nodeVm, _this.props.hierarchyHeader.structureOnlyHierarchy),
                };
            }),
                this.setState({ selectAll: !this.state.selectAll, selectionCriteria: updatedCriteria });
            this.props.onChangeSelectionCriteria(updatedCriteria);
        }
        else {
            this.setState({ selectAll: !this.state.selectAll, selectionCriteria: updatedCriteria });
            this.props.onChangeSelectionCriteria(updatedCriteria);
        }
        return !!this.state.selectAll;
    };
    Hierarchy.prototype.getHierarchyTypeUtil = function () {
        return HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil(this.props.hierarchyHeader.hierarchyType);
    };
    Hierarchy.prototype.selectLevels = function (values) {
        var _this = this;
        lodash_1.default.each(values, function (level) {
            var levelNodes = lodash_1.default.filter(_this.props.nodes, function (n) { return n.level.toString() === level; });
            lodash_1.default.each(levelNodes, function (nodeVm) {
                _this.onChangeSelectNode(nodeVm.nodeId, _this.getHierarchyTypeUtil().getNodeDisplayName({ nodeVm: nodeVm, fullName: true }), true);
            });
        });
    };
    Hierarchy.prototype.onChangeSelectNode = function (nodeId, name, isLevelSelect) {
        if (isLevelSelect === void 0) { isLevelSelect = false; }
        var updatedCriteria = __assign({}, this.state.selectionCriteria);
        var nodeVm = this.props.nodes[nodeId];
        // Handle deselecting a node
        if ((updatedCriteria.descendantsIncluded && updatedCriteria.descendantsIncluded[nodeId] && !isLevelSelect) ||
            (!this.state.selectItemAndBelow && isLevelSelect)) {
            delete updatedCriteria.descendantsIncluded[nodeId];
            this.updateSelectionCriteria(updatedCriteria);
            if (!(!this.state.selectItemAndBelow && isLevelSelect)) {
                return;
            }
        }
        else if ((updatedCriteria.singleIncluded && updatedCriteria.singleIncluded[nodeId] && !isLevelSelect) ||
            (this.state.selectItemAndBelow && isLevelSelect)) {
            delete updatedCriteria.singleIncluded[nodeId];
            this.updateSelectionCriteria(updatedCriteria);
            if (!(this.state.selectItemAndBelow && isLevelSelect)) {
                return;
            }
        }
        // Handle node selection
        if (this.state.selectItemAndBelow && updatedCriteria && updatedCriteria.descendantsIncluded) {
            updatedCriteria.descendantsIncluded[nodeId] = {
                name: name,
                id: nodeId,
                totalRollups: this.getHierarchyTypeUtil().getDescendantNodeCount(nodeVm, this.props.hierarchyHeader.structureOnlyHierarchy),
            };
            // Remove any node selection when an ancestor node is selected using descendantsIncluded option
            this.mergeNodeSelections(updatedCriteria, nodeId, isLevelSelect);
            this.updateSelectionCriteria(updatedCriteria);
            return;
        }
        else if (!this.state.selectItemAndBelow && updatedCriteria && updatedCriteria.singleIncluded) {
            updatedCriteria.singleIncluded[nodeId] = {
                name: name,
                id: nodeId,
                totalRollups: this.getHierarchyTypeUtil().getSingleNodeCount(nodeVm, this.props.hierarchyHeader.structureOnlyHierarchy),
            };
            this.updateSelectionCriteria(updatedCriteria);
            return;
        }
    };
    Hierarchy.prototype.mergeNodeSelections = function (updatedCriteria, nodeId, isLevelSelect) {
        var _this = this;
        if (this.props.nodes === undefined || this.props.parentIds === undefined) {
            return;
        }
        var singleAndDescendants = [updatedCriteria.singleIncluded, updatedCriteria.descendantsIncluded];
        var updatedIncludedList = [{}, {}];
        // For each node in selectionCriteria, check if currently selected node is an ancestor
        singleAndDescendants.forEach(function (includededList, index) {
            Object.keys(includededList).forEach(function (key) {
                var includeItem = true;
                var parentNodeId = _this.props.parentIds[includededList[key].id];
                while (parentNodeId !== undefined) {
                    if (parentNodeId === nodeId || (isLevelSelect && includededList[parentNodeId] !== undefined)) {
                        includeItem = false;
                        break;
                    }
                    parentNodeId = _this.props.parentIds[parentNodeId];
                }
                if (includeItem) {
                    updatedIncludedList[index][includededList[key].id] = includededList[key];
                }
            });
        });
        updatedCriteria.singleIncluded = updatedIncludedList[0];
        updatedCriteria.descendantsIncluded = updatedIncludedList[1];
    };
    Hierarchy.prototype.updateSelectionCriteria = function (updatedCriteria) {
        this.setState({ selectionCriteria: updatedCriteria });
        this.props.onChangeSelectionCriteria(updatedCriteria);
    };
    Hierarchy.prototype.getTopNode = function (nodeId, isOrphan) {
        if (this.props.nodes) {
            var nodeVm = this.props.nodes[nodeId];
            var hierarchyMetadataId = this.props.hierarchyHeader ? this.props.hierarchyHeader.hierarchyMetadataId : '0';
            if (nodeVm.isOrphan !== isOrphan) {
                return;
            }
            return (React.createElement(HierarchyStyledComponents_1.NodesList, { key: nodeVm.nodeId },
                React.createElement(Node_1.Node, __assign({ key: nodeVm.nodeId, disabled: this.props.disabled, nodeId: nodeVm.nodeId, isTopNode: true, hierarchyMetadataId: hierarchyMetadataId, pendingSelectedNodeScroll: this.props.pendingSelectedNodeScroll, level: 0, isOrphanBranch: false }, this.props, { selectItemAndBelow: this.state.selectItemAndBelow, selectAll: this.state.selectAll, parentChecked: false, onChangeSelectNode: this.onChangeSelectNode, selectionCriteria: this.state.selectionCriteria, showOwners: this.props.showOwners, hideCheckbox: this.props.hideCheckboxes }))));
        }
        return undefined;
    };
    Hierarchy.prototype.UpdateNodeIdsFromSelectionCriteria = function (nodeIds, nodes) {
        if (nodes) {
            Object.keys(nodes).forEach(function (k) {
                nodeIds[nodes[k].id] = true;
            });
        }
    };
    Hierarchy.prototype.UpdateSelectionCriteriaUsingInvalidIds = function (currentIncludedNodes, updatedIncludedNodes, isSingleIncluded) {
        var _this = this;
        var _a = this.props, invalidNodeIds = _a.invalidNodeIds, nodes = _a.nodes;
        if (!invalidNodeIds || !nodes) {
            return;
        }
        Object.keys(currentIncludedNodes).forEach(function (nodeId) {
            if (!(nodeId in invalidNodeIds)) {
                var nodeVm = nodes[nodeId];
                if (!nodeVm) {
                    return;
                }
                updatedIncludedNodes[nodeId] = {
                    name: _this.getHierarchyTypeUtil().getNodeDisplayName({ nodeVm: nodeVm, fullName: true }),
                    id: nodeId,
                    totalRollups: isSingleIncluded
                        ? _this.getHierarchyTypeUtil().getSingleNodeCount(nodeVm, _this.props.hierarchyHeader.structureOnlyHierarchy)
                        : _this.getHierarchyTypeUtil().getDescendantNodeCount(nodeVm, _this.props.hierarchyHeader.structureOnlyHierarchy),
                };
            }
        });
    };
    Hierarchy.prototype.SanitizeSelectionCriteria = function (prevProps) {
        if (this.props.selectionCriteria) {
            var currentNodeIds = {};
            var prevNodeIds_1 = {};
            this.UpdateNodeIdsFromSelectionCriteria(currentNodeIds, this.props.selectionCriteria.descendantsIncluded);
            this.UpdateNodeIdsFromSelectionCriteria(currentNodeIds, this.props.selectionCriteria.singleIncluded);
            if (prevProps && prevProps.selectionCriteria) {
                this.UpdateNodeIdsFromSelectionCriteria(prevNodeIds_1, prevProps.selectionCriteria.descendantsIncluded);
                this.UpdateNodeIdsFromSelectionCriteria(prevNodeIds_1, prevProps.selectionCriteria.singleIncluded);
            }
            var changed_1 = false;
            Object.keys(currentNodeIds).forEach(function (id) {
                if (!prevNodeIds_1[id]) {
                    changed_1 = true;
                }
            });
            if (changed_1 && Object.keys(currentNodeIds).length > 0) {
                this.props.fetchNodAncestors(Object.keys(currentNodeIds));
            }
        }
    };
    Hierarchy.defaultProps = {
        selectAll: false,
        disableSelectAll: false,
        hideselectItemRadioButtons: false,
        hideClearButton: false,
    };
    return Hierarchy;
}(React.PureComponent));
exports.Hierarchy = Hierarchy;
